import { Injectable } from '@angular/core';
import { AssignmentService } from '../../../assignment/core/assignment.service';
import { ngListService } from '../../../list/core/ng-list.service';
import { SectionService } from '../../../section/core/section.service';
import { FormConfigEditAssignment } from '../shared/form-config-edit-assignment';
import { FormConfigEditSection } from '../shared/form-config-edit-section';
import { FormConfigEditInlineAssignment } from '../shared/form-config-edit-inline-assignment';
import { FormConfigNewAssignmentWelcome } from '../shared/form-config-new-assignment-welcome';
import { FormType } from '../shared/form-type.enum';

@Injectable({
  providedIn: 'root'
})
export class FormConfigService {

  constructor(private listService : ngListService, private assignmentService : AssignmentService, private sectionService : SectionService) {}

  _config : {[key in FormType]? : any} = {
    [FormType.ASSIGNMENT] : () => new FormConfigEditAssignment(this.listService, this.assignmentService),
    [FormType.ASSIGNMENT_NEW_WELCOME] : () => new FormConfigNewAssignmentWelcome(this.assignmentService, this.listService),
    [FormType.ASSIGNMENT_INLINE] : () => new FormConfigEditInlineAssignment(this.assignmentService),
    [FormType.SECTION] : () => new FormConfigEditSection(this.sectionService)
  }
  
  getConfig(formType : FormType){
    if(this._config[formType]) return this._config[formType]();
    else console.error(`Please add a form config for type ${formType}`);
  }

}
